import { Component, Inject } from '@angular/core';
import { helper } from 'src/environments/helper';
import { DocumentData, EntityDocument, GeneralData } from '../../../document.interface';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { catchError, debounceTime, distinctUntilChanged, finalize, map, Observable, of, Subject, switchMap, takeUntil, tap, throwError } from 'rxjs';
import { SearchEntitate } from 'src/app/components/entitati/entitati.interface';
import { Generic, GenericCompartimentSearch } from 'src/app/interfaces/generic.interface';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DashboardService } from '../../../dashboard.service';
import { CommonService } from 'src/app/services/common.service';
import { NotificationService } from 'src/app/services/notification.service';
import { UserOrganigramaSearchPayload } from 'src/app/interfaces/common.interface';
import Swal from 'sweetalert2';
import { formatDate } from '@angular/common';

@Component({
    selector: 'app-edit-continut-document',
    templateUrl: './edit-continut-document.component.html',
    styleUrls: ['./edit-continut-document.component.scss']
})
export class EditContinutDocumentComponent {
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;

    successTitle: string = helper.dialogConfig.headers.success;
    successIcon: string = helper.dialogConfig.icons.success;
    successType: string = helper.dialogConfig.icons.success;
    helper = helper;

    today: Date = new Date();
    isLoading = false;

    docData: DocumentData | null = null;

    defaultTaraId: number | null = null;
    defaultTaraLabel = '';
    defaultJudetId: number | null = null;
    defaultJudetLabel = '';
    defaultLocalitateId: number | null = null;
    defaultLocalitateLabel = '';

    defaultParameter: { name: string; id: number } = {
        name: '--Alegeți--',
        id: -1,
    };

    formEmitent: FormGroup = new FormGroup({
        type: new FormControl(1, []), // Hard coded emitent
        id: new FormControl(null, []),
        id_address_type: new FormControl(1, []), // Cetatean default!
        denumire: new FormControl('', []),
        pers_contact: new FormControl('', []),
        denumire_select: new FormControl('', []),
        directie_id: new FormControl(null, []),
        directie_name: new FormControl('', []),
        compartiment_id: new FormControl(null, []),
        compartiment_name: new FormControl('', []),
        user_id: new FormControl(-1, []),
        user_name: new FormControl('', []),
        cnp_cui: new FormControl('', [Validators.required]), // Cetatean default!
        email: new FormControl('', []),
        telefon: new FormControl('', []),
        id_tara: new FormControl(this.defaultTaraId, []),
        name_tara: new FormControl(this.defaultTaraLabel, []),
        id_judet: new FormControl(this.defaultJudetId, []),
        name_judet: new FormControl(this.defaultJudetLabel, []),
        id_localitate: new FormControl(this.defaultLocalitateId, []),
        name_localitate: new FormControl(this.defaultLocalitateLabel, []),
        sector: new FormControl('-1', []),
        id_strada: new FormControl(null, []),
        name_strada: new FormControl('', []),
        numar: new FormControl('', []),
        bloc: new FormControl('', []),
        scara: new FormControl('', []),
        apartament: new FormControl('', []),
        cod_postal: new FormControl('', []),
        numar_deces: new FormControl('', []),
        data_deces_input: new FormControl('', []),
        person_status: new FormControl(false, []),
        observatii: new FormControl('', []),
    });

    private destroy$ = new Subject<void>();

    entitatiEmitent: SearchEntitate[] = [];
    entitatiEmitentControl = new FormControl();
    isEntitatiEmitentLoading = false;
    showEntitatiEmitentMessage = true;
    entitatiEmitentLoadComplete = false;

    entitatiEmitentByCNP: SearchEntitate[] = [];
    entitatiEmitentByCNPControl: FormControl<any> = new FormControl('', [Validators.required]);
    isEntitatiEmitentByCNPLoading = false;
    showEntitatiEmitentByCNPMessage = true;
    entitatiEmitentByCNPLoadComplete = false;

    directiiEmitent: Generic[] = [];
    filteredDirectiiEmitent: Generic[] = [];
    directiiEmitentControl = new FormControl();

    compartimenteEmitent: GenericCompartimentSearch[] = [];
    compartimenteEmitentControl = new FormControl();
    isCompartimenteEmitentLoading = false;
    showCompartimenteEmitentMessage = true;
    compartimenteEmitentLoadComplete = false;

    operatoriEmitent: Generic[] = [];
    filteredOperatoriEmitent: Generic[] = [];
    operatoriEmitentControl = new FormControl();

    tariEmitent: Generic[] = [];
    filteredTariEmitent: Generic[] = [];
    tariEmitentControl = new FormControl();

    judeteEmitent: Generic[] = [];
    filteredJudeteEmitent: Generic[] = [];
    judeteEmitentControl = new FormControl();

    localitatiEmitent: Generic[] = [];
    localitatiEmitentControl = new FormControl();
    isLocalitatiEmitentLoading = false;
    showLocalitatiEmitentMessage = true;
    localitatiEmitentLoadComplete = false;

    straziEmitent: Generic[] = [];
    straziEmitentControl = new FormControl();
    isStraziEmitentLoading = false;
    showStraziEmitentMessage = true;
    straziEmitentLoadComplete = false;
    lastStraziEmitentValue = '';

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            generalData: GeneralData[],
            docData: DocumentData,
        },
        private dialogRef: MatDialogRef<EditContinutDocumentComponent>,
        private dashboardService: DashboardService,
        private commonService: CommonService,
        private notificationService: NotificationService,
    ) {
        this.data.generalData.forEach(item => {
            if (item.name === 'default_adresa_tara' && Number(item.value) > 0 && item.label) {
                this.defaultTaraId = Number(item.value);
                this.defaultTaraLabel = item.label || '';
            } else if (item.name === 'default_adresa_judet' && Number(item.value) > 0 && item.label) {
                this.defaultJudetId = Number(item.value);
                this.defaultJudetLabel = item.label || '';
            } else if (item.name === 'default_adresa_localitate' && Number(item.value) > 0 && item.label) {
                this.defaultLocalitateId = Number(item.value);
                this.defaultLocalitateLabel = item.label || '';
            }
        })

        // If docData exists, it means the component is run from view doc!
        this.docData = data.docData ? data.docData : null;
    }

    ngOnInit() {
        this.loadDirectiiActive();

        this.loadTariActive();

        if (this.docData) {
            // Update emitent with docData
            if (this.docData.entity) this.updateFormEmitent(this.docData.entity);
            // Load default locatie emitent, if we don't have an address
            if (!this.docData.entity?.id_tara) this.loadDefaultLocatieEmitent();
        }

        this.entitatiEmitentControl.valueChanges.pipe(
            debounceTime(600)
        ).subscribe(value => {
            if (typeof value === 'string') {
                this.fetchEntitatiEmitent(value);
                this.showEntitatiEmitentMessage = true;
                this.entitatiEmitentLoadComplete = false;
            }
        });

        this.entitatiEmitentByCNPControl.valueChanges.pipe(
            debounceTime(600)
        ).subscribe(value => {
            if (typeof value === 'string') {
                this.fetchEntitatiEmitentByCNP(value);
                this.showEntitatiEmitentByCNPMessage = true;
                this.entitatiEmitentByCNPLoadComplete = false;
            }
        });

        this.compartimenteEmitentControl.valueChanges.pipe(
            debounceTime(600)
        ).subscribe(compartiment => {
            if (typeof compartiment === 'string') {
                this.fetchCompartimenteEmitent(compartiment);
                this.showCompartimenteEmitentMessage = true;
                this.compartimenteEmitentLoadComplete = false;
            }
        });

        this.localitatiEmitentControl.valueChanges.pipe(
            debounceTime(600)
        ).subscribe(localitate => {
            if (typeof localitate === 'string') {
                this.fetchLocalitatiEmitent(localitate);
                this.showLocalitatiEmitentMessage = true;
                this.localitatiEmitentLoadComplete = false;
            }
        });

        this.straziEmitentControl.valueChanges.pipe(
            debounceTime(600)
        ).subscribe(strada => {
            if (typeof strada === 'string') {
                this.fetchStraziEmitent(strada);
                this.showStraziEmitentMessage = true;
                this.straziEmitentLoadComplete = false;
            }
        });

        this.renderFieldsSearch();
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }


    // START -- Methods for getting data -- START
    renderFieldsSearch() {
        this.directiiEmitentControl.valueChanges.pipe(
            takeUntil(this.destroy$),
            distinctUntilChanged(),
            debounceTime(150),
            switchMap((inputValue) => {
                if (typeof inputValue !== 'string') {
                    return of(this.directiiEmitent);
                }
                if (inputValue.length < 1) {
                    this.filteredDirectiiEmitent = this.directiiEmitent;
                    return of(this.directiiEmitent);
                }
                return this.filterDirectiiEmitent(inputValue);
            }),
            tap((data: any[]) => {
                this.filteredDirectiiEmitent = data;
            }),
            catchError(() => of([]))
        ).subscribe();

        this.operatoriEmitentControl.valueChanges.pipe(
            takeUntil(this.destroy$),
            distinctUntilChanged(),
            debounceTime(150),
            switchMap((inputValue) => {
                if (typeof inputValue !== 'string') {
                    return of(this.operatoriEmitent);
                }
                if (inputValue.length < 1) {
                    this.filteredOperatoriEmitent = this.operatoriEmitent;
                    return of(this.operatoriEmitent);
                }
                return this.filterOperatoriEmitent(inputValue);
            }),
            tap((data: any[]) => {
                this.filteredOperatoriEmitent = data;
            }),
            catchError(() => of([]))
        ).subscribe();

        this.tariEmitentControl.valueChanges.pipe(
            takeUntil(this.destroy$),
            distinctUntilChanged(),
            debounceTime(150),
            switchMap((inputValue) => {
                if (typeof inputValue !== 'string') {
                    return of(this.tariEmitent);
                }
                if (inputValue.length < 1) {
                    this.filteredTariEmitent = this.tariEmitent;
                    return of(this.tariEmitent);
                }
                return this.filterTariEmitent(inputValue);
            }),
            tap((data: any[]) => {
                this.filteredTariEmitent = data;
            }),
            catchError(() => of([]))
        ).subscribe();

        this.judeteEmitentControl.valueChanges.pipe(
            takeUntil(this.destroy$),
            distinctUntilChanged(),
            debounceTime(150),
            switchMap((inputValue) => {
                if (typeof inputValue !== 'string') {
                    return of(this.judeteEmitent);
                }
                if (inputValue.length < 1) {
                    this.filteredJudeteEmitent = this.judeteEmitent;
                    return of(this.judeteEmitent);
                }
                return this.filterJudeteEmitent(inputValue);
            }),
            tap((data: any[]) => {
                this.filteredJudeteEmitent = data;
            }),
            catchError(() => of([]))
        ).subscribe();
    }

    fetchEntitatiEmitent(entitate: string) {
        if (entitate && entitate.length >= 2) {
            this.isEntitatiEmitentLoading = true;
            this.commonService.searchEntitati(entitate).subscribe({
                next: (response: SearchEntitate[]) => {
                    this.entitatiEmitent = response;
                    this.isEntitatiEmitentLoading = false;
                    this.entitatiEmitentLoadComplete = true;
                    this.showEntitatiEmitentMessage = this.entitatiEmitent.length === 0;
                },
                error: (err: any) => {
                    this.isEntitatiEmitentLoading = false;
                    this.showEntitatiEmitentMessage = true;
                    this.entitatiEmitentLoadComplete = true;
                    console.log(err);
                }
            });
        } else {
            this.entitatiEmitent = [];
            this.showEntitatiEmitentMessage = true;
            this.entitatiEmitentLoadComplete = false;
        }
    }

    onEntitateEmitentSelected(selectedEntitate: SearchEntitate) {
        if (selectedEntitate) {
            this.updateFormEmitent(selectedEntitate, 'name');
        }
    }

    displayEntitateEmitent(entitate: SearchEntitate): string {
        return entitate && entitate.denumire ? entitate.denumire : '';
    }

    onEntitateEmitentChange() {
        const currentValue = this.entitatiEmitentControl.value;

        if (typeof currentValue === 'string') {
            // this.formEmitent.controls['id'].patchValue(null); // No id reset when updating entity
            this.formEmitent.controls['denumire_select'].patchValue(currentValue);
        }
    }

    fetchEntitatiEmitentByCNP(cnp: string) {
        const currentEntitateType = this.formEmitent.get('id_address_type')?.value;

        if (cnp && cnp.length >= 2) {
            this.isEntitatiEmitentByCNPLoading = true;
            this.commonService.searchEntitatiByCNP(cnp, currentEntitateType).subscribe({
                next: (response: SearchEntitate[]) => {
                    this.entitatiEmitentByCNP = response;
                    this.isEntitatiEmitentByCNPLoading = false;
                    this.entitatiEmitentByCNPLoadComplete = true;
                    this.showEntitatiEmitentByCNPMessage = this.entitatiEmitentByCNP.length === 0;
                },
                error: (err: any) => {
                    this.isEntitatiEmitentByCNPLoading = false;
                    this.showEntitatiEmitentByCNPMessage = true;
                    this.entitatiEmitentByCNPLoadComplete = true;
                    console.log(err);
                }
            });
        } else {
            this.entitatiEmitentByCNP = [];
            this.showEntitatiEmitentByCNPMessage = true;
            this.entitatiEmitentByCNPLoadComplete = false;
        }
    }

    onEntitateEmitentByCNPSelected(selectedEntitate: SearchEntitate) {
        if (selectedEntitate) {
            this.updateFormEmitent(selectedEntitate, 'cnp');
        }
    }

    displayEntitateEmitentByCNP(entitate: SearchEntitate): string {
        return entitate && entitate.cnp_cui ? entitate.cnp_cui : '';
    }

    onEntitateEmitentByCNPChange() {
        const currentValue = this.entitatiEmitentByCNPControl.value;

        if (typeof currentValue === 'string') {
            // this.formEmitent.controls['id'].patchValue(null); // No id reset when updating entity
            this.formEmitent.controls['cnp_cui'].patchValue(currentValue);
        }
    }

    updateFormEmitent(selectedEntitate: SearchEntitate | EntityDocument, updateType?: 'name' | 'cnp') {
        const selectedEntitateType = selectedEntitate.id_address_type;
        const currentEntitateType = this.formEmitent.get('id_address_type')?.value;
        const searchedEntitati = this.entitatiEmitent;
        const searchedEntitatiByCNP = this.entitatiEmitentByCNP;

        if (selectedEntitateType !== currentEntitateType) {
            this.formEmitent.get('id_address_type')?.patchValue(selectedEntitateType);
            this.resetFormEmitent(selectedEntitateType);
        }

        if (updateType === 'name') {
            this.entitatiEmitent = searchedEntitati;
            this.entitatiEmitentByCNP = []
        }
        if (updateType === 'cnp') {
            this.entitatiEmitentByCNP = searchedEntitatiByCNP;
            this.entitatiEmitent = [];
        }

        if (selectedEntitateType === 1 || selectedEntitateType === 2 || selectedEntitateType === 3) {
            this.entitatiEmitentControl.setValue(selectedEntitate);
            this.formEmitent.get('id')?.patchValue(selectedEntitate.id);
            this.formEmitent.get('denumire_select')?.patchValue(selectedEntitate.denumire);
            this.formEmitent.get('denumire')?.patchValue(selectedEntitate.denumire);

            if (selectedEntitateType === 2 || selectedEntitateType === 3) {
                this.formEmitent.get('pers_contact')?.patchValue(selectedEntitate.pers_contact);
            }
            if (selectedEntitateType === 1 || selectedEntitateType === 2) {
                this.entitatiEmitentByCNPControl.setValue(selectedEntitate);
                this.formEmitent.get('cnp_cui')?.patchValue(selectedEntitate.cnp_cui);
                this.formEmitent.get('email')?.patchValue(selectedEntitate.email);
                this.formEmitent.get('telefon')?.patchValue(selectedEntitate.telefon);
            }
            if (selectedEntitate.id_tara && selectedEntitate.name_tara) {
                this.tariEmitentControl.setValue({
                    id: selectedEntitate.id_tara,
                    name: selectedEntitate.name_tara
                })
                this.formEmitent.get('id_tara')?.patchValue(selectedEntitate.id_tara);
                this.formEmitent.get('name_tara')?.patchValue(selectedEntitate.name_tara);
                this.loadJudeteEmitent(selectedEntitate.id_tara);
            }
            if (selectedEntitate.id_judet && selectedEntitate.name_judet) {
                this.judeteEmitentControl.setValue({
                    id: selectedEntitate.id_judet,
                    name: selectedEntitate.name_judet
                })
                this.formEmitent.get('id_judet')?.patchValue(selectedEntitate.id_judet);
                this.formEmitent.get('name_judet')?.patchValue(selectedEntitate.name_judet);
            }
            if (selectedEntitate.id_localitate && selectedEntitate.name_localitate) {
                this.fetchLocalitatiEmitent(selectedEntitate.name_localitate);
                this.localitatiEmitentControl.setValue({
                    id: selectedEntitate.id_localitate,
                    name: selectedEntitate.name_localitate
                })
                this.formEmitent.get('id_localitate')?.patchValue(selectedEntitate.id_localitate);
                this.formEmitent.get('name_localitate')?.patchValue(selectedEntitate.name_localitate);
            }
            if (selectedEntitate.id_strada && selectedEntitate.name_strada) {
                this.fetchStraziEmitent(selectedEntitate.name_strada);
                this.straziEmitentControl.setValue({
                    id: selectedEntitate.id_strada,
                    name: selectedEntitate.name_strada
                })
                this.formEmitent.get('id_strada')?.patchValue(selectedEntitate.id_strada);
                this.formEmitent.get('name_strada')?.patchValue(selectedEntitate.name_strada);
            }

            this.formEmitent.get('sector')?.patchValue(selectedEntitate.sector);
            this.formEmitent.get('numar')?.patchValue(selectedEntitate.numar);
            this.formEmitent.get('bloc')?.patchValue(selectedEntitate.bloc);
            this.formEmitent.get('scara')?.patchValue(selectedEntitate.scara);
            this.formEmitent.get('apartament')?.patchValue(selectedEntitate.apartament);
            this.formEmitent.get('cod_postal')?.patchValue(selectedEntitate.cod_postal);
            this.formEmitent.get('numar_deces')?.patchValue(selectedEntitate.numar_deces);
            this.formEmitent.get('data_deces_input')?.patchValue(selectedEntitate.data_deces);

            this.formEmitent.get('person_status')?.patchValue(selectedEntitate.person_status);
            this.formEmitent.get('observatii')?.patchValue(selectedEntitate.observatii);
        } else {
            this.directiiEmitentControl.setValue({
                id: selectedEntitate.directie_id,
                name: selectedEntitate.directie_name
            });
            this.formEmitent.get('directie_id')?.patchValue(selectedEntitate.directie_id);
            this.formEmitent.get('directie_name')?.patchValue(selectedEntitate.directie_name);

            this.compartimenteEmitentControl.setValue({
                id: selectedEntitate.compartiment_id,
                name: selectedEntitate.compartiment_name
            })
            this.formEmitent.get('compartiment_id')?.patchValue(selectedEntitate.compartiment_id);
            this.formEmitent.get('compartiment_name')?.patchValue(selectedEntitate.compartiment_name);

            this.loadOperatoriEmitent();
            this.formEmitent.get('user_id')?.patchValue(selectedEntitate.user_id);
            this.formEmitent.get('user_name')?.patchValue(selectedEntitate.user_name);
        }
    }

    loadDirectiiActive() {
        this.isLoading = true;
        this.commonService
            .getDirectiiActive()
            .pipe(
                map((results: any) => [...results]),
                finalize(() => this.isLoading = false)
            )
            .subscribe({
                next: (results) => {
                    this.directiiEmitent = results;

                    this.filteredDirectiiEmitent = [...this.directiiEmitent];
                },
                error: (error) => {
                    console.error('Error loading directii', error);
                    this.filteredDirectiiEmitent = [];
                },
            });
    }

    onDirectiiEmitentChange(selectedCompartiment: Generic): void {
        this.formEmitent.controls['directie_id'].patchValue(selectedCompartiment.id);
        this.formEmitent.controls['directie_name'].patchValue(selectedCompartiment.name);

        this.compartimenteEmitentControl.patchValue('');
        this.formEmitent.controls['compartiment_id'].patchValue('');
        this.formEmitent.controls['compartiment_name'].patchValue('');

        this.operatoriEmitent = [];
        this.filteredOperatoriEmitent = [];
        this.operatoriEmitentControl.patchValue('');
        this.formEmitent.controls['user_id'].patchValue(-1);
        this.formEmitent.controls['user_name'].patchValue('');
    }

    displayDirectiiEmitent(selectedDirectie: Generic): string {
        return selectedDirectie && selectedDirectie.name ? selectedDirectie.name : '';
    }

    onDirectiiEmitentBlur() {
        const currentValue = this.directiiEmitentControl.value;

        // If the value is a string (not an object), it means user didn't select from list
        if (typeof currentValue === 'string') {
            this.directiiEmitentControl.patchValue('');
            this.formEmitent.controls['directie_id'].patchValue('');
            this.formEmitent.controls['directie_name'].patchValue('');

            this.compartimenteEmitentControl.patchValue('');
            this.formEmitent.controls['compartiment_id'].patchValue('');
            this.formEmitent.controls['compartiment_name'].patchValue('');

            this.operatoriEmitent = [];
            this.filteredOperatoriEmitent = [];
            this.operatoriEmitentControl.patchValue('');
            this.formEmitent.controls['user_id'].patchValue(-1);
            this.formEmitent.controls['user_name'].patchValue('');
        }
    }

    fetchCompartimenteEmitent(compartiment: string) {
        // const directieEmitentValue = this.formEmitent.get('directie_id')?.value;
        // const directie = directieEmitentValue && directieEmitentValue !== -1 ? directieEmitentValue : undefined;
        if (compartiment.length >= 2) {
            this.isCompartimenteEmitentLoading = true;
            this.commonService.searchCompartimenteActive(undefined, compartiment).subscribe({
                next: (response: any) => {
                    this.compartimenteEmitent = response;
                    this.isCompartimenteEmitentLoading = false;
                    this.compartimenteEmitentLoadComplete = true;
                    this.showCompartimenteEmitentMessage = this.compartimenteEmitent.length === 0;
                },
                error: (err: any) => {
                    this.isCompartimenteEmitentLoading = false;
                    this.showCompartimenteEmitentMessage = true;
                    this.compartimenteEmitentLoadComplete = true;
                    console.log(err);
                }
            });
        } else {
            this.compartimenteEmitent = [];
            this.showCompartimenteEmitentMessage = true;
            this.compartimenteEmitentLoadComplete = false;
        }
    }

    onCompartimenteEmitentSelected(selectedCompartiment: GenericCompartimentSearch): void {
        this.formEmitent.controls['compartiment_id'].patchValue(selectedCompartiment.id);
        this.formEmitent.controls['compartiment_name'].patchValue(selectedCompartiment.name);

        this.directiiEmitentControl.setValue({
            id: selectedCompartiment.directie_id,
            name: selectedCompartiment.directie_name,
        });
        this.formEmitent.controls['directie_id'].patchValue(selectedCompartiment.directie_id);
        this.formEmitent.controls['directie_name'].patchValue(selectedCompartiment.directie_name);

        this.loadOperatoriEmitent();
        this.operatoriEmitentControl.patchValue('');
        this.formEmitent.controls['user_id'].patchValue(-1);
        this.formEmitent.controls['user_name'].patchValue('');
    }

    displayCompartimenteEmitent(selectedCompartiment: GenericCompartimentSearch): string {
        return selectedCompartiment && selectedCompartiment.name ? selectedCompartiment.name : '';
    }

    onCompartimenteEmitentBlur() {
        const currentValue = this.compartimenteEmitentControl.value;

        // If the value is a string (not an object), it means user didn't select from list
        if (typeof currentValue === 'string') {
            this.compartimenteEmitentControl.patchValue('');
            this.formEmitent.controls['compartiment_id'].patchValue('');
            this.formEmitent.controls['compartiment_name'].patchValue('');

            this.operatoriEmitent = [];
            this.filteredOperatoriEmitent = [];
            this.operatoriEmitentControl.patchValue('');
            this.formEmitent.controls['user_id'].patchValue(-1);
            this.formEmitent.controls['user_name'].patchValue('');
        }
    }

    loadOperatoriEmitent() {
        this.isLoading = true;
        const payload: UserOrganigramaSearchPayload = {
            directie_id: this.formEmitent.controls['directie_id'].value,
            compartiment_id: this.formEmitent.controls['compartiment_id'].value
        }
        this.commonService
            .getUsersByOrganigrama(payload)
            .pipe(
                map((results: any) => [...results]),
                finalize(() => { this.isLoading = false })
            ).subscribe({
                next: (data) => {
                    this.operatoriEmitent = [...data];
                    this.filteredOperatoriEmitent = [...this.operatoriEmitent];
                },
                error: (error) => {
                    console.error(error);
                    this.filteredOperatoriEmitent = [];
                },
            });
    }

    // onOperatoriEmitentClosed() {
    //     const selectedValue = this.operatoriEmitentControl.value;

    //     if (selectedValue) {
    //         const isSelectedInFilteredList = this.filteredOperatoriEmitent.some(operator =>
    //             operator.id === this.formEmitent.get('user_id')?.value
    //         );

    //         if (!isSelectedInFilteredList) {
    //             this.operatoriEmitentControl.setValue(null);
    //             this.filteredOperatoriEmitent = this.operatoriEmitent;
    //             this.destroy$.next();
    //             this.destroy$.complete();
    //             this.renderFieldsSearch();
    //         }
    //     }
    // }

    onOperatoriEmitentChange(operatorId: number): void {
        const selectedOperator = this.operatoriEmitent.find(operator => operator.id === operatorId);

        if (selectedOperator) {
            // this.formEmitent.controls['user_id'].patchValue(selectedOperator.id);
            this.formEmitent.controls['user_name'].patchValue(selectedOperator.name);
        }
    }

    // displayOperatoriEmitent(selectedOperator: Generic): string {
    //     return selectedOperator && selectedOperator.name ? selectedOperator.name : '';
    // }

    // onOperatoriEmitentBlur() {
    //     const currentValue = this.operatoriEmitentControl.value;

    //     // If the value is a string (not an object), it means user didn't select from list
    //     if (typeof currentValue === 'string') {
    //         this.operatoriEmitentControl.patchValue('');
    //         this.formEmitent.controls['user_id'].patchValue('');
    //         this.formEmitent.controls['user_name'].patchValue('');
    //     }
    // }

    loadTariActive() {
        this.isLoading = true;
        this.commonService
            .getTariActive()
            .pipe(
                takeUntil(this.destroy$),
                map((resp: Generic[]) => [...resp]),
                finalize(() => (this.isLoading = false))
            )
            .subscribe({
                next: (results) => {
                    this.tariEmitent = results;

                    this.filteredTariEmitent = [...this.tariEmitent];
                },
                error: (error) => {
                    console.error('Error loading tari', error);
                    this.filteredTariEmitent = [];
                },
            });
    }

    onTariEmitentChange(selectedTara: Generic): void {
        this.formEmitent.controls['id_tara'].patchValue(selectedTara.id);
        this.formEmitent.controls['name_tara'].patchValue(selectedTara.name);

        this.loadJudeteEmitent(selectedTara.id);
        this.judeteEmitentControl.patchValue('');
        this.formEmitent.controls['id_judet'].patchValue('');
        this.formEmitent.controls['name_judet'].patchValue('');

        this.localitatiEmitentControl.patchValue('');
        this.formEmitent.controls['id_localitate'].patchValue('');
        this.formEmitent.controls['name_localitate'].patchValue('');

        this.straziEmitentControl.patchValue('');
        this.formEmitent.controls['id_strada'].patchValue('');
        this.formEmitent.controls['name_strada'].patchValue('');
    }

    displayTariEmitent(selectedTara: Generic): string {
        return selectedTara && selectedTara.name ? selectedTara.name : '';
    }

    onTariEmitentBlur() {
        const currentValue = this.tariEmitentControl.value;

        // If the value is a string (not an object), it means user didn't select from list
        if (typeof currentValue === 'string') {
            this.tariEmitentControl.patchValue('');
            this.formEmitent.controls['id_tara'].patchValue('');
            this.formEmitent.controls['name_tara'].patchValue('');

            this.judeteEmitent = [];
            this.filteredJudeteEmitent = [];
            this.judeteEmitentControl.patchValue('');
            this.formEmitent.controls['id_judet'].patchValue('');
            this.formEmitent.controls['name_judet'].patchValue('');

            this.localitatiEmitentControl.patchValue('');
            this.formEmitent.controls['id_localitate'].patchValue('');
            this.formEmitent.controls['name_localitate'].patchValue('');

            this.straziEmitentControl.patchValue('');
            this.formEmitent.controls['id_strada'].patchValue('');
            this.formEmitent.controls['name_strada'].patchValue('');
        }
    }

    loadJudeteEmitent(taraId?: number) {
        this.isLoading = true;
        this.commonService
            .getJudeteActive(taraId)
            .pipe(
                takeUntil(this.destroy$),
                map((resp: Generic[]) => [...resp]),
                finalize(() => (this.isLoading = false))
            )
            .subscribe({
                next: (results) => {
                    this.judeteEmitent = results;
                    this.filteredJudeteEmitent = results;
                },
                error: (error) => {
                    console.error('Error loading judete', error);
                    this.filteredJudeteEmitent = [];
                },
            });
    }

    onJudeteEmitentChange(selectedJudet: Generic): void {
        this.formEmitent.controls['id_judet'].patchValue(selectedJudet.id);
        this.formEmitent.controls['name_judet'].patchValue(selectedJudet.name);

        this.localitatiEmitentControl.patchValue('');
        this.formEmitent.controls['id_localitate'].patchValue('');
        this.formEmitent.controls['name_localitate'].patchValue('');

        this.straziEmitentControl.patchValue('');
        this.formEmitent.controls['id_strada'].patchValue('');
        this.formEmitent.controls['name_strada'].patchValue('');
    }

    displayJudeteEmitent(selectedJudet: Generic): string {
        return selectedJudet && selectedJudet.name ? selectedJudet.name : '';
    }

    onJudeteEmitentBlur() {
        const currentValue = this.judeteEmitentControl.value;

        // If the value is a string (not an object), it means user didn't select from list
        if (typeof currentValue === 'string') {
            this.judeteEmitentControl.patchValue('');
            this.formEmitent.controls['id_judet'].patchValue('');
            this.formEmitent.controls['name_judet'].patchValue('');

            this.localitatiEmitentControl.patchValue('');
            this.formEmitent.controls['id_localitate'].patchValue('');
            this.formEmitent.controls['name_localitate'].patchValue('');

            this.straziEmitentControl.patchValue('');
            this.formEmitent.controls['id_strada'].patchValue('');
            this.formEmitent.controls['name_strada'].patchValue('');
        }
    }

    fetchLocalitatiEmitent(localitate: string) {
        const taraEmitentValue = this.formEmitent.get('id_tara')?.value;
        const judetEmitentValue = this.formEmitent.get('id_judet')?.value;
        const tara = taraEmitentValue && taraEmitentValue !== -1 ? this.formEmitent.get('id_tara')?.value : undefined;
        const judet = judetEmitentValue && judetEmitentValue !== -1 ? this.formEmitent.get('id_judet')?.value : undefined;
        if (localitate.length >= 2) {
            this.isLocalitatiEmitentLoading = true;
            this.commonService.getLocalitatiActive(tara, judet, localitate).subscribe({
                next: (response: any) => {
                    this.localitatiEmitent = response;
                    this.isLocalitatiEmitentLoading = false;
                    this.localitatiEmitentLoadComplete = true;
                    this.showLocalitatiEmitentMessage = this.localitatiEmitent.length === 0;
                },
                error: (err: any) => {
                    this.isLocalitatiEmitentLoading = false;
                    this.showLocalitatiEmitentMessage = true;
                    this.localitatiEmitentLoadComplete = true;
                    console.log(err);
                }
            });
        } else {
            this.localitatiEmitent = [];
            this.showLocalitatiEmitentMessage = true;
            this.localitatiEmitentLoadComplete = false;
        }
    }

    onLocalitatiEmitentSelected(selectedLocalitate: Generic) {
        if (selectedLocalitate) {
            this.formEmitent.controls['id_localitate'].patchValue(selectedLocalitate.id);
            this.formEmitent.controls['name_localitate'].patchValue(selectedLocalitate.name);
        }
    }

    displayLocalitatiEmitent(selectedLocalitate: Generic): string {
        return selectedLocalitate && selectedLocalitate.name ? selectedLocalitate.name : '';
    }

    onLocalitatiEmitentBlur() {
        const currentValue = this.localitatiEmitentControl.value;

        // If the value is a string (not an object), it means user didn't select from list
        if (typeof currentValue === 'string') {
            this.localitatiEmitentControl.patchValue('');
            this.formEmitent.controls['id_localitate'].patchValue('');
            this.formEmitent.controls['name_localitate'].patchValue('');

            this.straziEmitentControl.patchValue('');
            this.formEmitent.controls['id_strada'].patchValue('');
            this.formEmitent.controls['name_strada'].patchValue('');
        }
    }

    fetchStraziEmitent(strada: string) {
        this.fetchStraziEmitentObservable(strada).subscribe();
    }

    private fetchStraziEmitentObservable(strada: string) {
        const taraEmitentValue = this.formEmitent.get('id_tara')?.value;
        const judetEmitentValue = this.formEmitent.get('id_judet')?.value;
        const localitateEmitentValue = this.formEmitent.get('id_localitate')?.value;
        const tara = taraEmitentValue && taraEmitentValue !== -1 ? taraEmitentValue : undefined;
        const judet = judetEmitentValue && judetEmitentValue !== -1 ? judetEmitentValue : undefined;
        const localitate = localitateEmitentValue && localitateEmitentValue !== -1 ? localitateEmitentValue : undefined;

        if (strada.length >= 2) {
            this.lastStraziEmitentValue = strada;
            this.isStraziEmitentLoading = true;

            return this.commonService.getStraziActive(tara, judet, localitate, strada).pipe(
                takeUntil(this.destroy$),
                tap((response: any) => {
                    this.straziEmitent = response;
                    this.isStraziEmitentLoading = false;
                    this.straziEmitentLoadComplete = true;
                    this.showStraziEmitentMessage = this.straziEmitent.length === 0;
                }),
                catchError((err: any) => {
                    this.isStraziEmitentLoading = false;
                    this.showStraziEmitentMessage = true;
                    this.straziEmitentLoadComplete = true;
                    console.log(err);
                    return throwError(() => err);
                })
            );
        } else {
            this.straziEmitent = [];
            this.showStraziEmitentMessage = true;
            this.straziEmitentLoadComplete = false;
            return of([]);
        }
    }

    onStraziEmitentSelected(selectedStrada: Generic) {
        if (selectedStrada) {
            this.formEmitent.controls['id_strada'].patchValue(selectedStrada.id);
            this.formEmitent.controls['name_strada'].patchValue(selectedStrada.name);
        }
    }

    displayStraziEmitent(selectedStrada: Generic): string {
        return selectedStrada && selectedStrada.name ? selectedStrada.name : '';
    }

    onStraziEmitentBlur() {
        setTimeout(() => {
            const currentValue = this.straziEmitentControl.value;

            // If the value is a string (not an object), it means user didn't select from list
            if (typeof currentValue === 'string') {
                this.straziEmitentControl.patchValue('');
                this.formEmitent.controls['id_strada'].patchValue('');
                this.formEmitent.controls['name_strada'].patchValue('');
                this.lastStraziEmitentValue = '';
            }
        }, 2000);
    }

    addStraziEmitent() {
        this.isLoading = true;
        const payload = {
            name: this.lastStraziEmitentValue,
            id_country: this.formEmitent.get('id_tara')?.value,
            id_judet: this.formEmitent.get('id_judet')?.value,
            id_localitate: this.formEmitent.get('id_localitate')?.value,
        }

        // console.log(payload);
        this.commonService.storeStrada(payload)
            .pipe(
                switchMap(() => this.fetchStraziEmitentObservable(this.lastStraziEmitentValue)),
                finalize(() => (this.isLoading = false))
            )
            .subscribe({
                next: () => {
                    // Run fetchStraziEmitent first then fill the input with the new street data
                    if (this.straziEmitent && this.straziEmitent.length > 0) {
                        const foundStrada = this.straziEmitent[0];
                        this.straziEmitentControl.setValue(foundStrada);
                        this.formEmitent.controls['id_strada'].patchValue(foundStrada.id);
                        this.formEmitent.controls['name_strada'].patchValue(foundStrada.name);
                    }
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            })
    }

    normalizeString(value: string): string {
        return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    }

    filterDirectiiEmitent(searchTerm: string): Observable<any[]> {
        const normalizedSearchTerm = this.normalizeString(searchTerm);

        const filtered = this.directiiEmitent.filter(directie =>
            this.normalizeString(directie.name).includes(normalizedSearchTerm)
        );

        return of(filtered);
    }

    filterOperatoriEmitent(searchTerm: string): Observable<any[]> {
        const normalizedSearchTerm = this.normalizeString(searchTerm);

        const filtered = this.operatoriEmitent.filter(compartiment =>
            this.normalizeString(compartiment.name).includes(normalizedSearchTerm)
        );

        return of(filtered);
    }

    filterTariEmitent(searchTerm: string): Observable<any[]> {
        const normalizedSearchTerm = this.normalizeString(searchTerm);

        const filtered = this.tariEmitent.filter(tara =>
            this.normalizeString(tara.name).includes(normalizedSearchTerm)
        );

        return of(filtered);
    }

    filterJudeteEmitent(searchTerm: string): Observable<any[]> {
        const normalizedSearchTerm = this.normalizeString(searchTerm);

        const filtered = this.judeteEmitent.filter(judet =>
            this.normalizeString(judet.name).includes(normalizedSearchTerm)
        );

        return of(filtered);
    }
    // END -- Methods for getting data -- END


    resetFormEmitent(entitateType: number) {
        const cnp_cui = this.formEmitent.get('cnp_cui') as FormControl;

        if (entitateType === 1 || entitateType === 2) {
            cnp_cui.setValidators([Validators.required]);
            cnp_cui.markAsUntouched();
        } else {
            cnp_cui.patchValue('');
            cnp_cui.clearValidators();
            cnp_cui.setErrors(null);
            cnp_cui.markAsUntouched();
        }

        this.formEmitent.patchValue({
            id: null,
            // id_address_type: -1,
            denumire: '',
            pers_contact: '',
            denumire_select: '',
            directie_id: null,
            directie_name: '',
            compartiment_id: null,
            compartiment_name: '',
            user_id: -1,
            user_name: '',
            cnp_cui: '',
            email: '',
            telefon: '',
            id_tara: this.defaultTaraId,
            name_tara: this.defaultTaraLabel,
            id_judet: this.defaultJudetId,
            name_judet: this.defaultJudetLabel,
            id_localitate: this.defaultLocalitateId,
            name_localitate: this.defaultLocalitateLabel,
            sector: '-1',
            id_strada: null,
            name_strada: '',
            numar: '',
            bloc: '',
            scara: '',
            apartament: '',
            cod_postal: '',
            observatii: '',
        });
        this.resetFormEmitentFields();

        this.formEmitent.updateValueAndValidity();
    }
    resetFormEmitentFields() {
        this.entitatiEmitent = [];
        this.entitatiEmitentByCNP = [];
        this.entitatiEmitentControl.setValue('');
        this.entitatiEmitentByCNPControl.setValue('');

        this.filteredDirectiiEmitent = this.directiiEmitent;
        this.directiiEmitentControl.setValue('');

        this.compartimenteEmitent = [];
        this.compartimenteEmitentControl.setValue('');

        this.operatoriEmitent = [];
        this.filteredOperatoriEmitent = [];
        this.operatoriEmitentControl.setValue('');

        this.filteredTariEmitent = this.tariEmitent;
        this.tariEmitentControl.setValue('');

        this.judeteEmitent = [];
        this.filteredJudeteEmitent = [];
        this.judeteEmitentControl.setValue('');

        this.localitatiEmitent = [];
        this.localitatiEmitentControl.setValue('')

        this.straziEmitent = [];
        this.straziEmitentControl.setValue('')

        this.destroy$.next();
        this.destroy$.complete();
        this.renderFieldsSearch();

        this.loadDefaultLocatieEmitent();
    }
    loadDefaultLocatieEmitent() {
        this.tariEmitentControl.setValue({
            id: this.defaultTaraId,
            name: this.defaultTaraLabel
        })
        if (this.defaultTaraId) {
            this.loadJudeteEmitent(this.defaultTaraId);
            this.judeteEmitentControl.setValue({
                id: this.defaultJudetId,
                name: this.defaultJudetLabel
            })
        }
        if (this.defaultJudetLabel) {
            this.fetchLocalitatiEmitent(this.defaultJudetLabel);
            this.localitatiEmitentControl.setValue({
                id: this.defaultLocalitateId,
                name: this.defaultLocalitateLabel
            })
        }

        this.formEmitent.patchValue({
            id_tara: this.defaultTaraId,
            name_tara: this.defaultTaraLabel,
            id_judet: this.defaultJudetId,
            name_judet: this.defaultJudetLabel,
            id_localitate: this.defaultLocalitateId,
            name_localitate: this.defaultLocalitateLabel,
        })
    }

    submitForm() {
        Swal.fire({
            title: helper.dialogConfig.commonTitles.areYouSure,
            text: 'Vă rugăm să confirmați acest proces!',
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: helper.dialogConfig.buttonLabels.close,
            confirmButtonColor: helper.dialogConfig.colorButtons.standard,
            confirmButtonText: helper.dialogConfig.buttonLabels.confirm,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                this.updateDoc();
            }
        });
    }

    updateDoc() {
        this.isLoading = true;

        const data_deces_input = this.formEmitent.value.data_deces_input;

        const entity = {
            ...this.formEmitent.value,
            data_deces: data_deces_input ? formatDate(data_deces_input, 'yyyy-MM-dd', 'en-US') : '',
        };

        const payload = {
            entity,
        }

        // console.log(payload);
        this.dashboardService
            .updateEntity(this.docData!.id_document, payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    Swal.fire({
                        title: helper.dialogConfig.headers.success,
                        text: 'Emitent/Destinatar - Documentație actualizată cu succes',
                        icon: 'success',
                        confirmButtonText: this.helper.dialogConfig.buttonLabels.close,
                        allowOutsideClick: false,
                    }).then((result) => {
                        if (result.isConfirmed) {
                            this.dialogRef.close({ success: true });
                        }
                    });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
